import React from "react";
import { Box, Flex, Image, Text, Tooltip } from "@chakra-ui/react";

type EventCardProps = {
	eventName: string;
	clickAmount: number;
	arrowPositive?: boolean;
};
/**
 * Creates type of card used for the events
 *
 * @constructor
 */
export const EventCard = ({
	eventName,
	clickAmount,
	arrowPositive,
}: EventCardProps) => {
	const labelTooltip =
		"This component showcases the amount of clicks on " + eventName;
	return (
		<Tooltip label={labelTooltip}>
			<Flex
				direction="column"
				w="176px"
				h="101px"
				borderRadius="4px"
				border={".1px solid grey"}
				justifyContent="left"
				boxShadow="0px 4px 8px -7px rgba(0, 0, 0, 0.25)"
				padding="16px"
				fontFamily="Proxima-Nova-Medium"
			>
				<Text textColor="#8A8A8A" fontSize="10px">
					{eventName} Clicks
				</Text>
				<Box fontSize="40px" mt="-10px">
					{clickAmount}
				</Box>
				<Flex
					alignItems="center"
					fontSize="8px"
					fontFamily="Proxima-Nova"
					mt="-10px"
					gap="4px"
				>
					<Flex gap="8px" alignItems="center">
						<Image
							alignSelf="left"
							justifySelf="left"
							h="20px"
							w="20px"
							src={
								arrowPositive ?
									process.env.PUBLIC_URL + "/Analytics/" + "green-arrow.svg"
									: process.env.PUBLIC_URL + "/Analytics/" + "arrow.svg"
							}
							alt="Down Arrow"
						/>
						<Text
							textColor={arrowPositive ? "#00AE00" : "#FF0000"}
							fontSize="12px"
						>
							2.4%
						</Text>
					</Flex>
					<Text fontSize="8px" textColor="#727272">
						{" "}
						Than last week{" "}
					</Text>
				</Flex>
			</Flex>
		</Tooltip>
	);
};

EventCard.defaultProps = { eventName: "Event", arrowPositive: true };
export default EventCard;
